import React, { useState, useEffect } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

// Icons
const ArrowLeftIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
  </svg>
);

const CalendarIcon = () => (
<svg
      width="15"
      height="15"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_158)">
        <path
          d="M3.02222 20H16.9778C18.4407 20 19.6296 18.8111 19.6296 17.3481V4.13331C19.6296 2.67035 18.4407 1.48145 16.9778 1.48145H15.9259V0.740727C15.9259 0.333315 15.5926 0 15.1851 0C14.7777 0 14.4444 0.333315 14.4444 0.740727V1.48145H5.55557V0.740727C5.55557 0.333315 5.2222 0 4.81479 0C4.40737 0 4.07406 0.333315 4.07406 0.740727V1.48145H3.02222C1.55926 1.48145 0.370361 2.67035 0.370361 4.13331V17.3481C0.370361 18.8111 1.55926 20 3.02222 20ZM1.85188 4.13331C1.85188 3.48889 2.3778 2.96297 3.02222 2.96297H4.07406V3.7037C4.07406 4.11111 4.40737 4.44442 4.81479 4.44442C5.2222 4.44442 5.55551 4.11111 5.55551 3.7037V2.96297H14.4444V3.7037C14.4444 4.11111 14.7777 4.44442 15.1851 4.44442C15.5926 4.44442 15.9259 4.11111 15.9259 3.7037V2.96297H16.9777C17.6221 2.96297 18.1481 3.48889 18.1481 4.13331V17.3481C18.1481 17.9926 17.6221 18.5185 16.9777 18.5185H3.02222C2.3778 18.5185 1.85188 17.9926 1.85188 17.3481V4.13331Z"
          fill="currentColor"
        />
        <path
          d="M5.74085 8.51847C6.25222 8.51847 6.66676 8.10393 6.66676 7.59256C6.66676 7.0812 6.25222 6.66666 5.74085 6.66666C5.22948 6.66666 4.81494 7.0812 4.81494 7.59256C4.81494 8.10393 5.22948 8.51847 5.74085 8.51847Z"
          fill="currentColor"
        />
        <path
          d="M9.81482 8.51847C10.3262 8.51847 10.7407 8.10393 10.7407 7.59256C10.7407 7.0812 10.3262 6.66666 9.81482 6.66666C9.30346 6.66666 8.88892 7.0812 8.88892 7.59256C8.88892 8.10393 9.30346 8.51847 9.81482 8.51847Z"
          fill="currentColor"
        />
        <path
          d="M13.8888 8.51847C14.4002 8.51847 14.8147 8.10393 14.8147 7.59256C14.8147 7.0812 14.4002 6.66666 13.8888 6.66666C13.3774 6.66666 12.9629 7.0812 12.9629 7.59256C12.9629 8.10393 13.3774 8.51847 13.8888 8.51847Z"
          fill="currentColor"
        />
        <path
          d="M5.74085 12.2222C6.25222 12.2222 6.66676 11.8076 6.66676 11.2963C6.66676 10.7849 6.25222 10.3704 5.74085 10.3704C5.22948 10.3704 4.81494 10.7849 4.81494 11.2963C4.81494 11.8076 5.22948 12.2222 5.74085 12.2222Z"
          fill="currentColor"
        />
        <path
          d="M9.81482 12.2222C10.3262 12.2222 10.7407 11.8076 10.7407 11.2963C10.7407 10.7849 10.3262 10.3704 9.81482 10.3704C9.30346 10.3704 8.88892 10.7849 8.88892 11.2963C8.88892 11.8076 9.30346 12.2222 9.81482 12.2222Z"
          fill="currentColor"
        />
        <path
          d="M13.8888 12.2222C14.4002 12.2222 14.8147 11.8076 14.8147 11.2963C14.8147 10.7849 14.4002 10.3704 13.8888 10.3704C13.3774 10.3704 12.9629 10.7849 12.9629 11.2963C12.9629 11.8076 13.3774 12.2222 13.8888 12.2222Z"
          fill="currentColor"
        />
        <path
          d="M5.74085 15.9259C6.25222 15.9259 6.66676 15.5113 6.66676 15C6.66676 14.4886 6.25222 14.0741 5.74085 14.0741C5.22948 14.0741 4.81494 14.4886 4.81494 15C4.81494 15.5113 5.22948 15.9259 5.74085 15.9259Z"
          fill="currentColor"
        />
        <path
          d="M9.81482 15.9259C10.3262 15.9259 10.7407 15.5113 10.7407 15C10.7407 14.4886 10.3262 14.0741 9.81482 14.0741C9.30346 14.0741 8.88892 14.4886 8.88892 15C8.88892 15.5113 9.30346 15.9259 9.81482 15.9259Z"
          fill="currentColor"
        />
        <path
          d="M13.8888 15.9259C14.4002 15.9259 14.8147 15.5113 14.8147 15C14.8147 14.4886 14.4002 14.0741 13.8888 14.0741C13.3774 14.0741 12.9629 14.4886 12.9629 15C12.9629 15.5113 13.3774 15.9259 13.8888 15.9259Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_158">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
);

const UserPlusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M15,14C12.33,14 7,15.33 7,18V20H23V18C23,15.33 17.67,14 15,14M6,10V7H4V10H1V12H4V15H6V12H9V10M15,12A4,4 0 0,0 19,8A4,4 0 0,0 15,4A4,4 0 0,0 11,8A4,4 0 0,0 15,12Z"/>
  </svg>
);

const PulseSurveyHeader = ({ 
  title,
  description,
  createdBy,
  createdDate,
  updatedDate,
  surveyIsAnonymous,
  surveyIsOpen,
  task_template_id,
  compliance,
  onSelectClick,
  onChatClick,
  onCloseSurvey,
  onArchiveSurvey,
  backAction,
  showSelectButton = true
}) => {
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  const formatDateTime = (date, time) => {
    if (!date) return "N/A";
    return `${new Date(date).toLocaleDateString()}${time ? ` at ${time}` : ''}`;
  };

  const getCompletionRate = () => {
    if (compliance?.percentage !== undefined) {
      return compliance.percentage;
    }
    if (compliance?.respondedCount && compliance?.totalParticipants) {
      return Math.round((compliance.respondedCount / compliance.totalParticipants) * 100);
    }
    return 0;
  };

  return (
    <Container>
      {/* Header */}
      <HeaderSection>
        {/* {backAction && (
          <BackButton onClick={backAction}>
            <ArrowLeftIcon />
            <span>Back to Surveys</span>
          </BackButton>
        )} */}

        <HeaderContent>
          <IconWrapper>
            <CalendarIcon />
          </IconWrapper>
          <HeaderText>
            <Title>{title}</Title>
            <Subtitle>
              Pulse Survey • {getCompletionRate()}% completion rate
            </Subtitle>
          </HeaderText>
        </HeaderContent>

        <HeaderActions>
          {showSelectButton && onSelectClick && (
            <ActionButton onClick={onSelectClick}>
              <span>☰</span>
              <span>Select</span>
            </ActionButton>
          )}

          {onChatClick && (
            <ActionButton onClick={onChatClick}>
              <UserPlusIcon />
              <span>Chat with Data</span>
            </ActionButton>
          )}
        </HeaderActions>
      </HeaderSection>

      {/* Survey Details */}
      <SurveyDetailsSection>
        <SurveyDetailsCard>
          <CardHeader>
            <CardTitle>Survey Details</CardTitle>
          </CardHeader>
          <CardContent>
            <DetailsGrid>
              <DetailsItem>
                <DetailsLabel>Description</DetailsLabel>
                <DetailsValue>
                  {description || "No description provided"}
                </DetailsValue>
              </DetailsItem>
              <DetailsItem>
                <DetailsLabel>Created By</DetailsLabel>
                <DetailsValue>{createdBy || "Unknown"}</DetailsValue>
              </DetailsItem>
              <DetailsItem>
                <DetailsLabel>Created Date</DetailsLabel>
                <DetailsValue>{formatDate(createdDate)}</DetailsValue>
              </DetailsItem>
              <DetailsItem>
                <DetailsLabel>Updated Date</DetailsLabel>
                <DetailsValue>{formatDate(updatedDate)}</DetailsValue>
              </DetailsItem>
              <DetailsItem>
                <DetailsLabel>Anonymous Survey</DetailsLabel>
                <DetailsValue>{surveyIsAnonymous ? "Yes" : "No"}</DetailsValue>
              </DetailsItem>
              <DetailsItem>
                <DetailsLabel>Survey Status</DetailsLabel>
                <DetailsValue>
                  {surveyIsOpen ? "Active" : "Closed"}
                </DetailsValue>
              </DetailsItem>
            </DetailsGrid>
          </CardContent>
        </SurveyDetailsCard>

        <StatsCards>
          <StatCard>
            <StatValue>{compliance?.totalParticipants || 0}</StatValue>
            <StatLabel>Total Recipients</StatLabel>
          </StatCard>
          <StatCard>
            <StatValue>{compliance?.respondedCount || 0}</StatValue>
            <StatLabel>Completed</StatLabel>
          </StatCard>
          <StatCard>
            <StatValue>
              {(compliance?.totalParticipants || 0) -
                (compliance?.respondedCount || 0)}
            </StatValue>
            <StatLabel>Pending</StatLabel>
          </StatCard>
        </StatsCards>
      </SurveyDetailsSection>
    </Container>
  );
};

PulseSurveyHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  createdBy: PropTypes.string,
  createdDate: PropTypes.string,
  updatedDate: PropTypes.string,
  surveyIsAnonymous: PropTypes.bool,
  surveyIsOpen: PropTypes.bool,
  task_template_id: PropTypes.number,
  compliance: PropTypes.shape({
    percentage: PropTypes.number,
    respondedCount: PropTypes.number,
    totalParticipants: PropTypes.number,
  }),
  onSelectClick: PropTypes.func,
  onChatClick: PropTypes.func,
  onCloseSurvey: PropTypes.func,
  onArchiveSurvey: PropTypes.func,
  backAction: PropTypes.func,
  showSelectButton: PropTypes.bool,
};

export default PulseSurveyHeader;

// Styled Components
const Container = styled.div`
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
  animation: fadeIn 0.6s ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(16px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const HeaderSection = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e0e0e0;
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: transparent;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  color: #7e7e7e;
  font-family: "Poppins";
  font-weight: 400;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #f8f9fa;
    border-color: #c0c0c0;
  }
`;

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  flex: 1;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 7px;
`;

const HeaderText = styled.div``;

const Title = styled.h1`
  font-family: "Poppins";
  font-weight: 600;
  font-size: 24px;
  color: #414141;
  margin: 0 0 4px 0;
`;

const Subtitle = styled.p`
  font-family: "Poppins";
  font-weight: 400;
  font-size: 14px;
  color: #7e7e7e;
  margin: 0;
`;

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const ActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  background: #476dfa;
  border: none;
  border-radius: 7px;
  color: white;
  font-family: "Poppins";
  font-weight: 500;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: #3d5ce6;
  }
`;

const SurveyDetailsSection = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;
  margin-bottom: 24px;
  align-items: stretch;        /* make both columns match row height */
  min-height: 280px;           /* ensures a reasonable base height */
`;

const SurveyDetailsCard = styled.div`
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  height: 100%;                /* stretch to full row height */
`;

const CardHeader = styled.div`
  padding: 16px 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
`;

const CardTitle = styled.h3`
  font-family: "Poppins";
  font-weight: 600;
  font-size: 16px;
  color: #414141;
  margin: 0;
`;

const CardContent = styled.div`
  padding: 20px;
`;

const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
`;

const DetailsItem = styled.div``;

const DetailsLabel = styled.div`
  font-family: "Poppins";
  font-weight: 500;
  font-size: 12px;
  color: #7e7e7e;
  margin-bottom: 4px;
`;

const DetailsValue = styled.div`
  font-family: "Poppins";
  font-weight: 500;
  font-size: 14px;
  color: #414141;
`;

const StatsCards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;                /* match SurveyDetailsCard height */
  min-height: 100%;
`;

const StatCard = styled.div`
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  padding: 16px;
  text-align: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* Three cards, two gaps (2 * 12px = 24px) */
  flex: 0 0 calc((100% - 24px) / 3);
  height: calc((100% - 24px) / 3);
`;

const StatValue = styled.div`
  font-family: "Poppins";
  font-weight: 700;
  font-size: 28px;
  color: #476dfa;
  margin-bottom: 4px;
`;

const StatLabel = styled.div`
  font-family: "Poppins";
  font-weight: 500;
  font-size: 12px;
  color: #7e7e7e;
`;